import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LabelOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"label_outline"}/>
}
